export function copySiteConfig(siteConfig) {
  let newSiteConfig = { ...siteConfig };
  newSiteConfig.brandcolors = {};
  newSiteConfig.brandcolors.primarycolor = siteConfig.brandcolors.primarycolor;
  newSiteConfig.brandcolors.secondarycolor = siteConfig.brandcolors.secondarycolor;

  return newSiteConfig;
}